var host = 'http://192.168.0.146/electric.cq.com/'
if(process.env.NODE_ENV == 'development'){
  host = 'http://192.168.118.130/electric.cq.com/'
} else {
  host = 'http://zd.consec.top:8000'
  //baseURL ='http://192.168.118.112:8000'
}

import mixins from './mixins'
import common from './common/config'
import jsPDF from 'jspdf'
const VueConf = {
  install(Vue, { ElementUI }){

    function messageW( messaage ){
      ElementUI.Message({type: 'warning', message: messaage })
    }
    function messageS( messaage ){
      ElementUI.Message({type: 'success', message: messaage })
    }
    function messageE( messaage ){
      ElementUI.Message({type: 'error', message: messaage })
    }


    Vue.prototype.$r = messageW;
    Vue.prototype.$s = messageS;
    Vue.prototype.$e = messageE;

    Vue.prototype.$fixed = function( f ){
      return f < 10 ? '0' + f : f
    }

    // globally filter
    Vue.filter("formattime", function(value){
      if(!value) return;

      return new Date(value * 1000).Format("yyyy-MM-dd hh:mm")
    })
    Vue.filter('fullImage', function(path){
      if(!path){
        return 'static/default_pre.png'
      }
      return host + path
    })

    Vue.mixin(mixins)
    Vue.mixin({

      filters: {
        getDeviceWarningName(src, warning ){
          let warnings = {
            0: '保留',
            1: '过压或者欠压',
            2: '电弧',
            3: '温度',
            4: '过载',
            5: '漏电',
            6: '烟雾',
            7: '消防联动'
          }
          return warnings[warning]
        },
        getDeviceUnit(src, value){
          let units = {
            1: 'mA',
            2: 'A',
            3: '°C',
            4: 'V',
            5: ''
          }
          return  src + units[value]
        },
        warningListDataName(type, sort){
          let types = common.warningLogListFilterType.filter( item => item.value == type)[0].label;
          let sorts = {
            1: 'A',
            2: 'B',
            3: 'C'
          }
          return common.warningLogListFilterType.filter( item => item.value == type)[0].label
        },
        deviceLoopFullName(type, sort){
          if(type == 1){
             return '剩余电流'
          }
          if(type == 2){
            let subText = {
              1: 'A相',
              2: 'B相',
              3: 'C相',
              5: '剩余'
            }

            return `${subText[sort]}电流`
          }

          if(type == 3){
            let text = '温度'
            if(sort == 1){
              return `A相${text}`
            }
            if(sort == 2){
              return `B相${text}`
            }
            if(sort == 3){
              return `C相${text}`
            }
            if(sort == 4){
              return `箱体${text}`
            }
          }

          if(type == 4){
            let text = '电压'
            if(sort == 1){
              return `A相${text}`
            }
            if(sort == 2){
              return `B相${text}`
            }
            if(sort == 3){
              return `C相${text}`
            }
            if(sort == 4){
              return `箱体${text}`
            }
          }

          if(type == -1){
            return '电度'
          }

          if(type == -2){
            if(sort == 1){
              return '有功功率'
            }
            if(sort == 5){
              return '功率因素'
            }
          }
        },
        filterDeviceLoopSort(sort){
          if(sort == 0){
            return ''
          }
          if(sort == 1){
            return 'A相'
          }
          if(sort == 2){
            return 'B相'
          }
          if(sort == 3){
            return 'C相'
          }
          if(sort == 4){
            return '箱体'
          }
        },
        filterDeviceLoop(type){
          if(type == 1){
            return '剩余电流'
          }
          if(type == 2){
            return '电流'
          }
          if(type == 3){
            return '温度'
          }
          if(type == 4){
            return '电压'
          }
          if(type == 5){
            return '烟雾'
          }
          if(type == -1){
            return '电度'
          }
          if(type == -2){
            return '有功功率'
          }
        }
      },
      methods: {
        // 日期跨度 返回值为天数
        dateSpan(start, end){
          var start = new Date(start).getTime()
          var end = new Date(end).getTime()

          return Math.floor((end - start) / 86400000)
        },
        mergeObj(obj1,obj2){
          for(var key in obj2){
            obj1[key]=obj2[key]
          }
          return obj1;
        },
        downloadImage(name, data){
          var a = document.createElement('a');
          var event = new MouseEvent('click');
          a.href = data;
          a.download = name + '.png' || '图片.jpg';
          a.dispatchEvent(event)
        },
        exportAsPDF(name, data){

          var pdf = new jsPDF({
              orientation: 'landscape',
              unit: 'in',
              format: [16, 9]
          })
          pdf.addImage(data, 'jpeg', 0.5,0.5,15,8);
          pdf.save(name+'.pdf')
        },
        templateHistoryListUnit(type){

          var type_text = ''
          switch(type){
            case -1:
              type_text = 'KW/h';
              break;
            case -2:
              type_text = '';
              break;
            case -3:
              type_text = '';
              break;
            case -4:
              type_text = '';
              break;
            case 1:
              type_text = 'mA';
              break;
            case 2:
              type_text = 'A';
              break;
            case 3:
              type_text = '°C';
              break;
            case 4:
              type_text = 'V';
              break;
            case 5:
              type_text = '';
              break;
          }
          return type_text
        },
        templateHistoryListDataname( type, sort){
          var type_text = ''
          var sorts = {
            1: 'A相',
            2: 'B相',
            3: 'C相',
            4: '箱体',
          }
          switch(type){
            case -1:
              type_text = '电度';
              break;
            case -2:
              type_text = '有功功率';
              break;
            case -3:
              type_text = '功率因素';
              break;
            case -4:
              type_text = '电弧';
              break;
            case 1:
              type_text = '剩余电流';
              break;
            case 2:
              type_text = `${sorts[sort]}电流`;
              break;
            case 3:
              type_text = `${sorts[sort]}温度`;
              break;
            case 4:
              type_text = `${sorts[sort]}电压`;
              break;
            case 5:
              type_text = `烟雾`;
              break;
          }

          return type_text
        },
        getStore(key){
          return this.$store.state[key]
        },
        pathTo(path){
          this.$router.push({path})
        },
        renderRandomCode( dom ){
            //1.新建一个函数产生随机数
          function rn(min,max){
              return  parseInt(Math.random()*(max-min)+min);
          }
          //2.新建一个函数产生随机颜色
          function rc(min,max){
              var r=rn(min,max);
              var g=rn(min,max);
              var b=rn(min,max);
              return `rgb(${r},${g},${b})`;
          }
          //3.填充背景颜色,颜色要浅一点
          var w=120;
          var h=40;
          var ctx=dom.getContext("2d");
          ctx.fillStyle=rc(180,230);
          ctx.fillRect(0,0,w,h);
          //4.随机产生字符串
          var pool="ABCDEFGHIJKLIMNOPQRSTUVWSYZ1234567890";
          var randomCode = ''
          for(let i=0;i<4;i++){
              var c=pool[rn(0,pool.length)];//随机的字
              var fs=rn(18,40);//字体的大小
              var deg=rn(-30,30);//字体的旋转角度
              ctx.font=fs+'px Simhei';
              ctx.textBaseline="top";
              ctx.fillStyle=rc(80,150);
              ctx.save();
              ctx.translate(30*i+15,15);
              ctx.rotate(deg*Math.PI/180);
              ctx.fillText(c,-15+5,-15);
              ctx.restore();

              randomCode += c
          }
          this.$store.commit('randomCode', randomCode)
          //5.随机产生5条干扰线,干扰线的颜色要浅一点
          for(var i=0;i<5;i++){
              ctx.beginPath();
              ctx.moveTo(rn(0,w),rn(0,h));
              ctx.lineTo(rn(0,w),rn(0,h));
              ctx.strokeStyle=rc(180,230);
              ctx.closePath();
              ctx.stroke();
          }
          //6.随机产生40个干扰的小点
          for(var i=0;i<40;i++){
              ctx.beginPath();
              ctx.arc(rn(0,w),rn(0,h),1,0,2*Math.PI);
              ctx.closePath();
              ctx.fillStyle=rc(150,200);
              ctx.fill();
          }
        },
        getDeviceTypeNameByParam(loop_type, loop_sort){
          // loop_type 回路类型
          // loop_sort 回路顺序
          let loopType = {
            1: '电流',
            2: '电流',
            3: '温度',
            4: '电压',
            5: '烟雾'
          }
          let loopSort = {
            1: 'A相',
            2: 'B相',
            3: 'C相',
            4: '箱体'
          }
          if(loop_type == 1){
            return '剩余电流'
          }
          return loopSort[loop_sort]+loopType[loop_type]
        },

      }
    })
  }
}

export default VueConf



// WEBPACK FOOTER //
// ./src/VueConf.js